"use client";

import Link from "next/link";
import BookOpenIcon from "../../components/Icons/BookOpenIcon";
import MenuIcon from "../../components/Icons/MenuIcon";
import XIcon from "../../components/Icons/XIcon";
import { LOGIN_URL } from "@/utils/constants";
import useSession from "@/hooks/useSession";
import AccountMenu from "@/app/components/AccountMenu";

export default function DocsHeader({ isMobileMenuOpen, onToggleMenu }) {
  const { status, user } = useSession();
  const isAuthenticated = status === "authenticated" && user;

  return (
    <header className="docs-original-header sticky top-0 z-50 w-full border-b border-[#E5E5E5] bg-white/95 backdrop-blur-sm supports-[backdrop-filter]:bg-white/80">
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-14 sm:h-16 items-center justify-between gap-2">
          <div className="flex items-center gap-3">
            {onToggleMenu && (
              <button
                onClick={onToggleMenu}
                className="lg:hidden p-2 text-[#171717] hover:bg-neutral-100 rounded-[10px] transition-colors flex-shrink-0"
                aria-label={isMobileMenuOpen ? "Close menu" : "Open menu"}
              >
                {isMobileMenuOpen ? (
                  <XIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                ) : (
                  <MenuIcon className="w-5 h-5 sm:w-6 sm:h-6" />
                )}
              </button>
            )}

            <div className="flex items-center space-x-2">
              <BookOpenIcon className="w-4 h-4 lg:w-5 lg:h-5 text-[#525252]" />
              <span className="text-base lg:text-lg font-medium text-[#171717] whitespace-nowrap sentient-medium">
                Help Center
              </span>
            </div>
          </div>

          <div className="flex items-center space-x-2 lg:space-x-4 flex-shrink-0">
            {isAuthenticated ? (
              <AccountMenu user={user} />
            ) : (
              <Link
                href={LOGIN_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-[#171717] hover:text-[#525252] border border-[#171717] hover:border-[#525252] rounded-[10px] transition-colors whitespace-nowrap geist-medium"
              >
                Sign In
              </Link>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
